import React from "react";
// import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import { gql } from "apollo-boost";
import Activity from "./Activity";
import {
  JobActivitiesQuery,
  ServiceActivitiesQuery,
  fragments as activityFragments
} from "../../queries/Activities";
import { addToCache, deleteFromCache } from "../../utils/queryHelpers";
import CommentForm from "./CommentForm";
import CenteredLoader from "../CenteredLoader";
import withCurrentUser from "../../hocs/withCurrentUser";

const activitiesByDate = (a, b) => {
  const dateA = new Date(a.createdAt);
  const dateB = new Date(b.createdAt);
  return dateB - dateA;
};

const renderActivityList = ({
  activities,
  currentUser,
  updateComment,
  deleteComment
}) =>
  [...activities].sort(activitiesByDate).map(activity => {
    const canUpdate = activity.actor && currentUser.id === activity.actor.id;
    return (
      <Activity
        activity={activity}
        key={activity.id}
        deleteComment={canUpdate ? deleteComment : undefined}
        updateComment={canUpdate ? updateComment : undefined}
        showService={false}
      />
    );
  });

export const ActivityFeed = ({
  match,
  data: { loading, activities },
  addComment,
  userData: { currentUser },
  updateComment,
  deleteComment,
  className
}) => {
  if (loading && !activities) return <CenteredLoader />;

  return (
    <div className={className}>
      <CommentForm onSubmit={addComment} serviceId={match.params.serviceId} />
      {renderActivityList({
        activities,
        updateComment,
        deleteComment,
        currentUser
      })}
    </div>
  );
};

export const DeleteCommentMutation = gql`
  mutation deleteComment($id: ID!) {
    deleteComment(id: $id) {
      id
      createdAt
    }
  }
`;

const AddCommentMutation = gql`
  mutation addComment($serviceId: ID!, $input: ActivityInput!) {
    addComment(serviceId: $serviceId, input: $input) {
      ...ActivityFeedActivity
    }
  }
  ${activityFragments.activity}
`;

const UpdateCommentMutation = gql`
  mutation updateComment($id: ID!, $input: ActivityInput!) {
    updateComment(id: $id, input: $input) {
      ...ActivityFeedActivity
    }
  }
  ${activityFragments.activity}
`;

const enhance = compose(
  withRouter,
  withCurrentUser(),
  graphql(DeleteCommentMutation, {
    props({ ownProps: { match: { params: { jobId, serviceId } } }, mutate }) {
      return {
        deleteComment({ id }) {
          return mutate({
            variables: { id },
            update: (store, result) => {
              deleteFromCache(id, store, "activities", {
                query: ServiceActivitiesQuery,
                variables: { serviceId }
              });
              deleteFromCache(id, store, "activities", {
                query: JobActivitiesQuery,
                variables: { jobId }
              });
            }
          });
        }
      };
    }
  }),
  graphql(AddCommentMutation, {
    props({ ownProps: { match: { params: { jobId, serviceId } } }, mutate }) {
      return {
        addComment({ serviceId, input }) {
          return mutate({
            variables: { serviceId, input },
            update: (store, { data: { addComment } }) => {
              addToCache(addComment, store, "activities", {
                query: ServiceActivitiesQuery,
                variables: { serviceId }
              });
              addToCache(addComment, store, "activities", {
                query: JobActivitiesQuery,
                variables: { jobId }
              });
            }
          });
        }
      };
    }
  }),
  graphql(UpdateCommentMutation, {
    props({ ownProps: { match: { params: { jobId, serviceId } } }, mutate }) {
      return {
        updateComment({ id, input }) {
          return mutate({
            variables: { id, input }
          });
        }
      };
    }
  }),
  graphql(ServiceActivitiesQuery, {
    options: ({ match: { params: { serviceId } } }) => ({
      variables: { serviceId },
      pollInterval: 1000 * 10
    })
  })
);

export default enhance(ActivityFeed);



// WEBPACK FOOTER //
// ./src/components/activities/ActivityFeed.js